/* CheapBats Bat Genie page (2026-09-07) — standalone version of the PDP sizing guide.
   Sizing logic = Mike's BatReviews Bat Genie (youth/fastpitch age-anchored) + JustBats H×W grid
   (BBCOR/wood/tee ball), identical to assets/cb-size-guide.js. Adds a bat-type step and lands
   on the filtered collection. Source: InventorySOT/theme_src/home/ */
(function () {
  'use strict';
  var CERTS = {
    usa:        { name: 'USA Baseball', coll: 'usa-baseball-bats',       mode: 'youth', who: 'Little League, Cal Ripken, PONY, most rec leagues' },
    usssa:      { name: 'USSSA',        coll: 'usssa-baseball-bats',     mode: 'youth', who: 'Travel / select ball (1.15 BPF stamp)' },
    bbcor:      { name: 'BBCOR',        coll: 'bbcor-bats',              mode: 'hw',    who: 'High school & college (-3)' },
    wood:       { name: 'Wood',         coll: 'wood-bats',               mode: 'hw',    who: 'Adult wood-bat leagues, practice, pro-style' },
    coachpitch: { name: 'Coach Pitch',  coll: 'coach-pitch-bats',        mode: 'youth', who: 'Ages 5–8, USA stamp' },
    teeball:    { name: 'Tee Ball',     coll: 'tee-ball-bats',           mode: 'tee',   who: 'Ages 4–6' },
    fastpitch:  { name: 'Fastpitch',    coll: 'fastpitch-softball-bats', mode: 'youth', who: 'Girls’ & women’s fastpitch' },
    slowpitch:  { name: 'Slowpitch',    coll: 'slowpitch-softball-bats', mode: 'sp',    who: 'Adult rec & league (USA/ASA, USSSA, NSA, ISA)' }
  };
  var HW_GRID = [
    [29, 30, 30, 31, 31, 31, 31, 32, 32, 32, 32],
    [29, 30, 31, 31, 32, 32, 32, 32, 33, 33, 33],
    [30, 31, 31, 32, 32, 32, 32, 33, 33, 33, 33],
    [31, 31, 32, 32, 33, 33, 33, 33, 33, 33, 33],
    [32, 32, 32, 33, 33, 33, 33, 33, 34, 34, 34],
    [32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 34]
  ];
  function recSpWeight(A) {
    var pts = 0, h = A.height || 70, w = A.weight || 190;
    if (w <= 155 || h <= 66) pts -= 1; else if (w >= 215 || h >= 75) pts += 1;
    if (A.style === 'contact') pts -= 1; else if (A.style === 'power') pts += 1;
    if (A.feel === 'light') pts -= 1; else if (A.feel === 'heavy') pts += 1;
    return pts <= -1 ? 25 : pts <= 1 ? 26 : pts === 2 ? 27 : 28;
  }
  function recLength(cert, A) {
    var mode = CERTS[cert].mode, h = A.height || 0;
    if (mode === 'sp') return 34;
    if (mode === 'tee') return h <= 38 ? 24 : h <= 44 ? 25 : 26;
    if (mode === 'hw') {
      var hi = h <= 65 ? 0 : h <= 69 ? 1 : h <= 71 ? 2 : h <= 73 ? 3 : h <= 75 ? 4 : 5;
      var w = A.weight || 0;
      var wi = w <= 110 ? 0 : w <= 120 ? 1 : w <= 130 ? 2 : w <= 140 ? 3 : w <= 150 ? 4 : w <= 160 ? 5 : w <= 170 ? 6 : w <= 180 ? 7 : w <= 190 ? 8 : w <= 200 ? 9 : 10;
      return HW_GRID[hi][wi];
    }
    var a = A.age || 11;
    var aL = a <= 5 ? 25 : a === 6 ? 26 : a === 7 ? 27 : a === 8 ? 28 : a === 9 ? 29 : a <= 11 ? 30 : a <= 13 ? 31 : a === 14 ? 32 : 33;
    var typ = { 5: 43, 6: 45, 7: 48, 8: 50, 9: 52, 10: 54, 11: 56, 12: 58, 13: 60, 14: 63 }[a] || (a >= 15 ? (cert === 'fastpitch' ? 65 : 68) : 54);
    var adj = 0;
    if (h) { var d = h - typ, up = a <= 10 ? 9 : (a <= 12 ? 7 : 6); if (d >= up) adj = 1; else if (d <= -6) adj = -1; }
    if ((a === 11 || a === 12) && A.style === 'power' && adj < 1) adj = 1;
    var L = aL + adj;
    return cert === 'fastpitch' ? Math.max(26, Math.min(34, L)) : Math.max(24, Math.min(33, L));
  }
  function recDrops(cert, A) {
    var mode = CERTS[cert].mode;
    if (cert === 'bbcor' || cert === 'wood') return [-3];
    if (mode === 'sp') return [];
    if (mode === 'tee') return [-10, -11, -12, -13];
    var a = A.age || 11, pwr = A.style === 'power';
    if (cert === 'fastpitch') {
      if (a <= 8) return [-12, -13, -11]; if (a <= 10) return [-11, -12, -10]; if (a <= 12) return [-10, -11, -9]; if (a <= 14) return [-9, -10, -8]; return [-8, -9, -10];
    }
    if (a <= 6) return [-12, -11, -10]; if (a <= 8) return [-11, -10, -12]; if (a <= 9) return [-10, -11]; if (a <= 10) return [-10];
    if (a <= 11) return pwr ? [-8, -10] : [-10, -8]; if (a <= 12) return pwr ? [-8, -10, -5] : [-10, -8]; if (a <= 13) return [-8, -5]; return [-5, -8];
  }
  function collUrl(cert, L, drops) {
    var C = CERTS[cert];
    if (C.mode === 'sp') return '/collections/' + C.coll + '?filter.v.m.custom.bat_weight=' + encodeURIComponent(L + ' oz');
    var u = '/collections/' + C.coll + '?filter.v.m.custom.bat_length=' + encodeURIComponent(L + '"');
    (drops || []).forEach(function (d) { u += '&filter.p.m.custom.drop=' + encodeURIComponent(String(d)); });
    return u;
  }
  function ftIn(h) { return Math.floor(h / 12) + "'" + (h % 12) + '"'; }

  // ---------- UI ----------
  var root = document.querySelector('[data-cb-genie]'); if (!root) return;
  var A = { cert: null, age: null, height: null, weight: null, style: null, feel: null };
  var stepEl = root.querySelector('[data-genie-steps]'), resEl = root.querySelector('[data-genie-result]');

  function h(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function btn(label, sub, on, sel) { var b = h('button', 'cbg-btn' + (sel ? ' is-on' : ''), '<b>' + label + '</b>' + (sub ? '<span>' + sub + '</span>' : '')); b.type = 'button'; b.addEventListener('click', on); return b; }
  function pills(name, opts, key) {
    var w = h('div', 'cbg-pills'); opts.forEach(function (o) { w.appendChild(btn(o[1], o[2] || '', function () { A[key] = o[0]; render(); }, A[key] === o[0])); }); return w;
  }
  function numRow(label, key, min, max, step, fmt) {
    var w = h('div', 'cbg-row'); w.appendChild(h('label', null, label));
    var inp = h('input'); inp.type = 'range'; inp.min = min; inp.max = max; inp.step = step; inp.value = A[key] != null ? A[key] : Math.round((min + max) / 2);
    var out = h('output', null, A[key] != null ? fmt(A[key]) : '—');
    inp.addEventListener('input', function () { A[key] = +inp.value; out.textContent = fmt(A[key]); renderResult(); });
    inp.addEventListener('change', function () { A[key] = +inp.value; render(); });
    w.appendChild(inp); w.appendChild(out); return w;
  }
  function section(title, sub) { var s = h('div', 'cbg-step'); s.appendChild(h('h2', null, title)); if (sub) s.appendChild(h('p', 'cbg-sub', sub)); return s; }

  function render() {
    stepEl.innerHTML = '';
    var s1 = section('1. What kind of bat?', 'Pick the stamp your league requires. Not sure? Pick by level below.');
    var grid = h('div', 'cbg-grid');
    [['usa', 'USA Baseball'], ['usssa', 'USSSA'], ['bbcor', 'BBCOR'], ['wood', 'Wood'], ['coachpitch', 'Coach Pitch'], ['teeball', 'Tee Ball'], ['fastpitch', 'Fastpitch Softball'], ['slowpitch', 'Slowpitch Softball']].forEach(function (c) {
      grid.appendChild(btn(c[1], CERTS[c[0]].who, function () { A.cert = c[0]; if (CERTS[c[0]].mode !== 'youth') A.age = null; render(); }, A.cert === c[0]));
    });
    s1.appendChild(grid); stepEl.appendChild(s1);
    if (!A.cert) { resEl.hidden = true; return; }
    var C = CERTS[A.cert], mode = C.mode;
    var s2 = section('2. About the player');
    if (mode === 'youth') s2.appendChild(numRow('Age', 'age', 5, 18, 1, function (v) { return v + (v >= 18 ? '+' : ''); }));
    if (mode !== 'sp') s2.appendChild(numRow('Height', 'height', mode === 'tee' ? 34 : 40, 80, 1, ftIn));
    else s2.appendChild(numRow('Height', 'height', 58, 80, 1, ftIn));
    if (mode === 'hw' || mode === 'sp' || mode === 'youth') s2.appendChild(numRow('Weight', 'weight', mode === 'youth' ? 40 : 100, 300, 5, function (v) { return v + ' lb'; }));
    if (mode !== 'tee' && A.cert !== 'bbcor' && A.cert !== 'wood') { s2.appendChild(h('label', 'cbg-lbl', 'Hitter type')); s2.appendChild(pills('style', [['contact', 'Contact', 'bat speed & control'], ['power', 'Power', 'drives the ball']], 'style')); }
    if (mode === 'sp') { s2.appendChild(h('label', 'cbg-lbl', 'Preferred feel')); s2.appendChild(pills('feel', [['light', 'Lighter'], ['medium', 'Middle'], ['heavy', 'Heavier']], 'feel')); }
    stepEl.appendChild(s2);
    renderResult();
  }
  function ready() {
    var m = CERTS[A.cert].mode;
    if (m === 'youth') return A.age != null && A.height != null;
    if (m === 'tee') return A.height != null;
    if (m === 'hw') return A.height != null && A.weight != null;
    return A.style != null && A.feel != null;
  }
  function renderResult() {
    if (!A.cert || !ready()) { resEl.hidden = true; return; }
    var C = CERTS[A.cert], mode = C.mode, html = '';
    if (mode === 'sp') {
      var oz = recSpWeight(A);
      html += '<div class="cbg-res__lbl">Recommended weight</div><div class="cbg-res__big">' + oz + ' oz <small>34" barrel</small></div>';
      html += '<p>Slowpitch bats are all 34" — the choice is weight. ' + oz + ' oz fits a ' + (A.style === 'power' ? 'power' : 'contact') + ' hitter who likes a ' + A.feel + ' swing. Most CheapBats customers swing 26 oz; go 25 for bat speed, 27–28 for mass.</p>';
      html += '<a class="cbg-cta" href="' + collUrl(A.cert, oz) + '">Shop ' + oz + ' oz slowpitch bats</a>';
      html += '<div class="cbg-alt">Also try: <a href="' + collUrl(A.cert, oz - 1) + '">' + (oz - 1) + ' oz</a> · <a href="' + collUrl(A.cert, oz + 1) + '">' + (oz + 1) + ' oz</a></div>';
    } else {
      var L = recLength(A.cert, A), drops = recDrops(A.cert, A), main = drops.slice(0, 2);
      html += '<div class="cbg-res__lbl">Recommended length</div><div class="cbg-res__big">' + L + '"' + (drops.length ? ' <small>drop ' + main.join(' / ') + '</small>' : '') + '</div>';
      if (mode === 'youth') html += '<p>Based on age ' + A.age + (A.height ? ' at ' + ftIn(A.height) : '') + '. Drop ' + main.join(' or ') + ' is the normal range at this age' + (A.style === 'power' ? ' — a strong hitter can handle the heavier end' : '') + '. If the player has to muscle the bat, go lighter first, then shorter.</p>';
      else if (mode === 'hw') html += '<p>' + C.name + ' bats are -3. At ' + ftIn(A.height) + ' / ' + A.weight + ' lb the industry chart says ' + L + '". Contact hitters often like an inch shorter for control.</p>';
      else html += '<p>Tee ball bats run 24–26" and -10 to -13. At ' + ftIn(A.height) + ' start at ' + L + '".</p>';
      html += '<a class="cbg-cta" href="' + collUrl(A.cert, L, main) + '">Shop ' + L + '" ' + C.name + ' bats</a>';
      html += '<div class="cbg-alt">Also try: <a href="' + collUrl(A.cert, L - 1, main) + '">' + (L - 1) + '"</a> · <a href="' + collUrl(A.cert, L + 1, main) + '">' + (L + 1) + '"</a>' + (drops.length > 2 ? ' · <a href="' + collUrl(A.cert, L, [drops[2]]) + '">drop ' + drops[2] + '</a>' : '') + '</div>';
    }
    resEl.innerHTML = html; resEl.hidden = false;
  }
  render();
})();
